export default __webpack_public_path__ + "static/media/68e8c8706dd1b8d75e1b9f54a40d21e41602177597742.1fbefda2.webp";